import createSelectors from './createSelectors';
import PermissionsDomain from '../models/PermissionsDomain';

const Select = createSelectors(PermissionsDomain);

export default Select;
